import PageHeader from '@/components/common/PageHeader.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';

export default function DashboardDetail({ selection, onBack }) {
  if (!selection) {
    return null;
  }
  const title = selection.type === 'categoria' ? `Categoría: ${selection.data.categoria}` : `Cliente #${selection.data.clienteId}`;
  const quantity = selection.data.cantidad;

  return (
    <div className="w-full">
      <PageHeader
        title={title}
        subtitle="Detalle de distribución"
        actions={(
          <button
            type="button"
            onClick={onBack}
            className="rounded-xl border border-[rgba(var(--border),0.6)] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--subpanel),0.6)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Volver
          </button>
        )}
      />

      <section className="mx-auto mt-6 w-full max-w-[900px] space-y-6">
        <div className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
          <p className="text-sm text-[rgba(var(--muted),0.95)]">
            {selection.type === 'categoria'
              ? 'Esta categoría concentra la siguiente cantidad de tickets en el periodo analizado.'
              : 'Este cliente generó la siguiente cantidad de tickets durante el periodo filtrado.'}
          </p>
          <p className="mt-6 text-5xl font-semibold text-[rgb(var(--fg))]">{quantity}</p>
        </div>
      </section>

      <StickyActions>
        <span className="text-xs text-[rgba(var(--muted),0.9)]">Utilizá el menú para volver al resumen.</span>
      </StickyActions>
    </div>
  );
}
